var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7165 6H8.28683C7.02455 6 6 7.02455 6 8.28683V39.7132C6 40.9754 7.02455 42 8.28683 42H39.7132C40.9754 42 42 40.9754 42 39.7165V8.28683C42 7.02455 40.9754 6 39.7165 6ZM25.7143 33.5859C25.7143 37.0112 23.7054 38.5714 20.7723 38.5714C18.1205 38.5714 16.2087 36.7935 15.4286 35.1429L18.1239 33.5123C18.6429 34.433 19.433 35.1429 20.5714 35.1429C21.6596 35.1429 22.2857 34.7176 22.2857 33.0636V22.2857H25.7143V33.5859ZM33.1507 38.5714C30.1138 38.5714 28.3895 37.0413 27.4286 35.1429L30 33.4286C30.6998 34.5737 31.4632 35.6685 33.077 35.6685C34.433 35.6685 35.1429 34.9922 35.1429 34.0547C35.1429 32.9364 34.4062 32.5379 32.9163 31.885L32.0993 31.5335C29.7388 30.529 28.1685 29.2701 28.1685 26.6049C28.1685 24.154 30.0402 22.2857 32.9598 22.2857C35.0391 22.2857 36.5324 23.0089 37.6105 24.904L35.0658 26.5413C34.5033 25.5335 33.9007 25.1384 32.9598 25.1384C32.0022 25.1384 31.3962 25.7478 31.3962 26.5413C31.3962 27.5223 32.0022 27.9174 33.4051 28.5268L34.2221 28.8783C37.0045 30.067 38.5714 31.2824 38.5714 34.0145C38.5714 36.9576 36.2578 38.5714 33.1507 38.5714Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.eeea6d0116d14c5cb6871dc61e1fe80e.svg";
export { ForwardRef as ReactComponent };